<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    created() {
      let id = localStorage.getItem('uId')
      console.log(id);
      if (id) {
        this.$store.dispatch('getUserInfo2', id);
      } else {
        this.$store.commit('LOG_OUT', 0)
      }
      // if (JSON.parse(localStorage.getItem('uInfo')).id) {
      //   this.$store.commit('SET_USERINFO', JSON.parse(localStorage.getItem('uInfo')))
      // } else {
      // }
    }
  }
</script>

<style>
  #app {
    /*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue